import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import l from '../../../lang';
import { Button } from '../../common/button';
import Card from '../../common/card';
import CardDescription from '../../common/card-description';
import Tabs from '../../common/tabs';
import TopDashboardSection from '../../common/top-dashboard-section';
import Plans from './plans';
import './styles.scss';
import Subscriptors from './subscribers';
import { ReactComponent as PlusIcon } from '../../../assets/icons/plus.svg';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../../config/routes';
import { AuthSelectors } from '../../../store/auth/selectors';
import { canCreatePlan, canViewSubscriptions } from '../../../store/subscriptions/roles';

const Subscriptions: FC<{ initTabSelected: number }> = ({ initTabSelected }) => {
  const history = useHistory();
  const [tabSelected, setTabSelected] = useState(initTabSelected);
  const roles = useSelector(AuthSelectors.getRoles);
  const canCreate = canCreatePlan(roles);
  const canView = canViewSubscriptions(roles);

  return (
    <div className="subscriptions">
      <TopDashboardSection title={l('menu.item.SUBSCRIPTIONS')} subtitle={l('subscriptions.list.subheadline')} />
      <Card>
        <CardDescription>{l('subscriptions.subheadline')}</CardDescription>
        <div className="subscriptions__create_btn">
          <Button fullWidth startIcon={<PlusIcon />} onClick={() => history.push(Routes.SUBSCRIPTIONS_PLANS_CREATE)} disabled={!canCreate}>
            {l('subscriptions.createPlan')}
          </Button>
        </div>
        {canView && (
          <div className="subscriptions__content">
            <Tabs
              id="subscriptions"
              idxItemSelected={tabSelected}
              items={[
                {
                  title: l('subscriptions.subscriptors'),
                  content: <Subscriptors />,
                },
                {
                  title: l('subscriptions.plans'),
                  content: <Plans />,
                },
              ]}
              onChange={idx => setTabSelected(idx)}
            />
          </div>
        )}
      </Card>
    </div>
  );
};

export default Subscriptions;
